export default {
  name: 'time-tracking-no-tracking-pane',
  template: `
    <div class="time-tracking-no-tracking-pane">
      <span class="no-value">
        {{ __('No estimate or time spent') }}
      </span>
    </div>
  `,
};



// WEBPACK FOOTER //
// ./sidebar/components/time_tracking/no_tracking_pane.js